// extracted by mini-css-extract-plugin
export default {"list":"FilmsList_list__6IrtY"};